import Layout from "../../../Layouts/Layout";
import React from "react";
import AccountPersonalData from "../../../../components/MyAccount/PersonalData";
import AccountPassword from "../../../../components/MyAccount/Password";
import AccountDelete from "../../../../components/MyAccount/AccountDelete";
import myAccountPageStyle from "./myAccountPageStyle";
import { Helmet } from "react-helmet-async";
import Paper from "@mui/material/Paper";
import ContentBoxHead from "../../../../components/Box/ContentBox/ContentBoxHead";
import IconPersonal from "../../../../assets/icons/generic/IconDocument";
import IconAccount from "../../../../assets/icons/generic/IconAccount";
import Grid from "@mui/material/Grid";
import PageNavigation from "../../../../components/Navigation/SummaryNavigation/PageNavigation";
import { Box } from "@mui/material";
import CallRecordConsent from "../../../../components/MyAccount/CallRecordConsent";

export default function MyAccountPage() {
  const navigationLinks = [
    {
      target: "#personalData",
      label: "Daten ändern",
    },
    {
      target: "#password",
      label: "Passwort ändern",
    },
    {
      target: "#callRecordConsent",
      label: "Persönliche Zusammenfassung von Beratungsgesprächen",
    },
    {
      target: "#delete",
      label: "Konto löschen",
    },
  ];

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>Mein Konto | Legalbird</title>
      </Helmet>
      <Box sx={myAccountPageStyle.container}>
        <PageNavigation navigationLinks={navigationLinks} headerIcon={IconAccount} headline={"Mein Konto"} />
        <Paper elevation={4} sx={myAccountPageStyle.paper}>
          <Grid container sx={{
            justifyContent: "center"
          }}>
            <Grid>
              <ContentBoxHead headline={"Konto-Daten ändern"} Icon={IconPersonal} />
            </Grid>
          </Grid>
          <Box sx={myAccountPageStyle.scrollToAnchor} id={"personalData"} />
          <AccountPersonalData />
        </Paper>
        <Box sx={myAccountPageStyle.scrollToAnchor} id={"password"} />
        <AccountPassword />
        <Box sx={myAccountPageStyle.scrollToAnchor} id={"callRecordConsent"} />
        <CallRecordConsent />
        <Box sx={myAccountPageStyle.scrollToAnchor} id={"delete"} />
        <AccountDelete />
      </Box>
    </Layout>
  );
}
